var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24272A",
    fillRule: "nonzero",
    d: "M12.1085714,6 L10.4285714,6 L10.4285714,3.38571429 C10.4285714,1.51714286 8.89428571,0 7,0 C5.10571429,0 3.57142857,1.51714286 3.57142857,3.38571429 L3.57142857,6 L1.82285714,6 C1.35142857,6 1,6.3 1,6.77142857 L1,12.6942857 C1,13.1571429 1.35142857,13.7142857 1.82285714,13.7142857 L12.1085714,13.7142857 C12.58,13.7142857 13,13.1571429 13,12.6942857 L13,6.77142857 C13,6.3 12.58,6 12.1085714,6 Z M5.28571429,6 L5.28571429,3.38571429 C5.28571429,2.45142857 6.05714286,1.69714286 7,1.69714286 C7.94285714,1.69714286 8.71428571,2.45142857 8.71428571,3.38571429 L8.71428571,6 L5.28571429,6 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9bc02223e9ce1d39cf1ef9d087037bd1.svg";
export { ForwardRef as ReactComponent };